// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"6":"3980ddf7","141":"937e5666","348":"04c78f4d","385":"b4349fa6","704":"cc309d7f","713":"239b22cd","806":"58018bb3","963":"da17357c","970":"31847ef6"}[chunkId] + ".css";
};